module.exports = __webpack_public_path__ + "static/media/YM52_2.0f464653.jpg";